﻿import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { CANALS } from '@/api/activacions';
import type { Canal } from '@/api/types';
import { Icona, type NomIcona } from '@/components/Icona';
import { Avatar } from '@/pages/operacio/comu';

const ICONA_CANAL: Record<string, NomIcona> = {
  EMAIL: 'envelope',
  TRUCADA: 'phone',
  SMS: 'message',
  PUSH: 'bell',
  PUSH_CRITICA: 'bell-badge',
};

/** Xips commutables de canals (canals per defecte d'un servei, canals d'una persona). */
export function CanalsChips({
  valor,
  onCanvia,
  disabled,
  etiqueta,
}: {
  valor: Canal[];
  onCanvia: (c: Canal[]) => void;
  disabled?: boolean;
  etiqueta: string;
}) {
  const tc = useTranslation('comu').t;
  return (
    <div className="chips" role="group" aria-label={etiqueta}>
      {CANALS.map((c) => {
        const actiu = valor.includes(c);
        return (
          <button
            key={c}
            type="button"
            className="chip-canal"
            aria-pressed={actiu}
            disabled={disabled}
            onClick={() => onCanvia(actiu ? valor.filter((x) => x !== c) : [...valor, c])}
          >
            <Icona nom={ICONA_CANAL[c] ?? 'bell'} />
            {tc(`canal.${c}`)}
          </button>
        );
      })}
    </div>
  );
}

/** Persona de guàrdia: avatar, nom i línia secundària. */
export function PersonaGuardia({
  nom,
  sub,
  suplent,
}: {
  nom: string;
  sub?: ReactNode;
  suplent?: boolean;
}) {
  return (
    <div className="est-persona">
      <Avatar nom={nom} color={suplent ? 'bg-green' : 'bg-brand'} />
      <div className="est-persona__text">
        <strong>{nom}</strong>
        {sub ? <span>{sub}</span> : null}
      </div>
    </div>
  );
}

/** Capçalera d'una fitxa: ruta, nom, insígnies i accions. */
export function FitxaCap({
  ruta,
  titol,
  badges,
  children,
}: {
  ruta: string;
  titol: string;
  badges?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="fitxa-cap">
      <div className="fitxa-cap__titols">
        <span className="fitxa-cap__ruta">{ruta}</span>
        <h2>{titol}</h2>
        {badges ? <div className="fitxa-cap__badges">{badges}</div> : null}
      </div>
      {children ? <div className="fitxa-cap__accions">{children}</div> : null}
    </div>
  );
}
